import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function ProfessionalSearch({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="ID do Profissional"
        name={[fieldName, 'action', 'data', 'profissional_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
    </>
  )
}
